import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ActionCreators } from '@redux-devtools/core';
import LogMonitorButton from './LogMonitorButton';
// eslint-disable-next-line @typescript-eslint/unbound-method
const {
  reset,
  rollback,
  commit,
  sweep
} = ActionCreators;
const style = {
  textAlign: 'center',
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  borderColor: 'transparent',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'row'
};
export default class LogMonitorButtonBar extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleRollback", () => {
      this.props.dispatch(rollback());
    });
    _defineProperty(this, "handleSweep", () => {
      this.props.dispatch(sweep());
    });
    _defineProperty(this, "handleCommit", () => {
      this.props.dispatch(commit());
    });
    _defineProperty(this, "handleReset", () => {
      this.props.dispatch(reset());
    });
  }
  render() {
    const {
      theme,
      hasStates,
      hasSkippedActions
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        ...style,
        borderColor: theme.base02
      }
    }, /*#__PURE__*/React.createElement(LogMonitorButton, {
      theme: theme,
      onClick: this.handleReset,
      enabled: true
    }, "Reset"), /*#__PURE__*/React.createElement(LogMonitorButton, {
      theme: theme,
      onClick: this.handleRollback,
      enabled: hasStates
    }, "Revert"), /*#__PURE__*/React.createElement(LogMonitorButton, {
      theme: theme,
      onClick: this.handleSweep,
      enabled: hasSkippedActions
    }, "Sweep"), /*#__PURE__*/React.createElement(LogMonitorButton, {
      theme: theme,
      onClick: this.handleCommit,
      enabled: hasStates
    }, "Commit"));
  }
}
_defineProperty(LogMonitorButtonBar, "propTypes", {
  dispatch: PropTypes.func,
  theme: PropTypes.object
});